T.Hero = Class(
	/**
	 * @lends {T.Hero#}
	 */
	{
		__construct(par) {
			this.node = mkE({
				tag: 'div',
				id: 'hero-background',
				els: [
					this._backgroundPicture = mkE({
						tag: 'div',
						id: 'hero-background-picture'
					})
				]
			});

			if (par.className) {
				addClassName(this.node, par.className);
			}

			if (par.backgroundClass) {
				addClassName(this._backgroundPicture, par.backgroundClass);
			}

			if (par.backgroundUrl) {
				this._backgroundPicture.style.backgroundImage = `url('${par.backgroundUrl}')`;
			}

			if (par.backgroundOverlay) {
				mkE({
					tag: 'div',
					id: 'hero-background-overlay'
				}).append(this.node);
			}

			if (par.backgroundArrow) {
				let arrowNode = mkE({
					tag: 'div',
					id: 'hero-background-arrow'
				});
				if (par.backgroundArrowAnimated) {
					addClassName(arrowNode, 'animated');
				}
				arrowNode.append(this.node);
			}

			if (par.backgroundMask) {
				mkE({
					tag: 'div',
					id: 'hero-background-mask',
					className: `mask-${par.backgroundMask}`
				}).append(this.node);
			}

			mkE({
				tag: 'div',
				className: 'container',
				els: [
					this._content = mkE({
						tag: 'div',
						id: 'hero-content'
					})
				]
			}).append(this.node);

			if (par.title) {
				let title = mkE({
					tag: 'h1',
					className: 'hero-title'
				}).append(this._content);
				mkE.appendTypeElement(title, par.title);
			}

			if (par.text) {
				let text = mkE({
					tag: 'p',
					className: 'hero-text'
				}).append(this._content);
				mkE.appendTypeElement(text, par.text);
				D.replaceWithNode(text, /\n/g, () => {
					return mkE({
						tag: 'br'
					});
				});
			}

			if (par.button) {
				let button = mkE({
					tag: 'div',
					className: 'hero-button-container'
				}).append(this._content);
				mkE.appendTypeElement(button, par.button);
			}

			if (par.downloadButtons) {
				mkE({
					tag: 'div',
					className: 'hero-download-buttons',
					els: [
						new T.Download()
					]
				}).append(this._content);
			}
		}
	},
	mkE.Base
);